import { useIntl } from "react-intl";

const EmbeddedKnowledgeBase = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EmbeddedKnowledgeBase.header",
            defaultMessage: "Embedded knowledge base"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EmbeddedKnowledgeBase.body",
            defaultMessage:
                "Create, read, update, and delete knowledge articles directly within Jira Service Management."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default EmbeddedKnowledgeBase;
